import { render, staticRenderFns } from "./App.vue?vue&type=template&id=bb8bed28&scoped=true"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"
import style0 from "./App.vue?vue&type=style&index=0&id=bb8bed28&prod&lang=scss&scoped=true"
import style1 from "./App.vue?vue&type=style&index=1&id=bb8bed28&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_61f4c95fbe53a3b57a2489edae5a9b2f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8bed28",
  null
  
)

export default component.exports